import { addDays, addMonths, isAfter } from "date-fns";

const BANK_TRANSFER_DUE_THRESHOLD_MONTHS = 2;
const BANK_TRANSFER_FULL_TERM_DAYS = 14;

// Keep the Orders UI aligned with Outstanding Payments: the order creation
// date, not the historical invoice creation date, starts the payment term.
export const calculateBankTransferDueDate = (
  orderCreatedAt: Date,
  showLiveStart?: string
): Date | undefined => {
  if (!showLiveStart) return undefined;

  const liveStart = new Date(showLiveStart);
  if (Number.isNaN(liveStart.getTime())) return undefined;

  const hasFullTerm = isAfter(
    liveStart,
    addMonths(orderCreatedAt, BANK_TRANSFER_DUE_THRESHOLD_MONTHS)
  );

  return hasFullTerm
    ? addDays(orderCreatedAt, BANK_TRANSFER_FULL_TERM_DAYS)
    : orderCreatedAt;
};
